import React from 'react';

import View from './view';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';
import {Sex} from '../../../../../shared/models/profile/sex';
import {useStyles} from '../../../../../shared/hooks/styles';
import {Text} from '../../../../../shared/components/text';
import {datePipe} from '../../../../../shared/pipes/date';
import {capitalize, capitalizeAndAddDot} from '../../../../../shared/utils/text';

export const ProfileBaseInfo = () => {
  const styles = useStyles(({theme}) => {
    return {
      prop: {
        textAlign: 'right',
        maxWidth: 180,
        ...theme.fonts.body,
        color: theme.color.textColor,
        opacity: 1,
      },
      label: {
        ...theme.fonts.bodySmallLight,
        color: theme.color.labelText,
      },
    };
  });
  const profile = useSelector(holderProfileSelector());
  if (!profile) {
    return null;
  }

  const properties: {value: JSX.Element}[] = [
    {
      value: (
        <>
          <Text testID='common-surname-label-id' style={styles.label}>
            Фамилия:
          </Text>
          <Text testID='common-surname-value-id' style={styles.prop}>
            {capitalizeAndAddDot(profile.lastName)}
          </Text>
        </>
      ),
    },
    {
      value: (
        <>
          <Text testID='common-name-label-id' style={styles.label}>
            Имя:
          </Text>
          <Text testID='common-name-value-id' style={styles.prop}>
            {capitalize(profile.firstName)}
          </Text>
        </>
      ),
    },
    {
      value: (
        <>
          <Text testID='common-patronymic-label-id' style={styles.label}>
            Отчество:
          </Text>
          <Text testID='common-patronymyc-value-id' style={styles.prop}>
            {capitalize(profile.middleName)}
          </Text>
        </>
      ),
    },
    {
      value: (
        <>
          <Text testID='common-gender-label-id' style={styles.label}>
            Пол:
          </Text>
          <Text testID='common-gender-value-id' style={styles.prop}>
            {profile.sex === Sex.male ? 'Мужской' : 'Женский'}
          </Text>
        </>
      ),
    },
    {
      value: (
        <>
          <Text testID='common-birthday-label-id' style={styles.label}>
            Дата рождения:
          </Text>
          <Text testID='common-gender-value-id' style={styles.prop}>
            {datePipe(profile.birthDate)}
          </Text>
        </>
      ),
    },
  ];

  return React.createElement(View, {properties});
};
